import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useFullTrack } from '../../tracks';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const ExamIncompleteExercisesScreen = ({
  trackId,
  language
}) => {
  const {
    track,
    trackLoading,
    trackError
  } = useFullTrack(trackId, language);
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    error: trackError,
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.practicalsIncomplete"
    }),
    illustration: "announcement",
    language: language,
    loading: trackLoading,
    showSecondaryRetakeCTA: true,
    subheading: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "learningCenter.exams.finished.practicalsIncompleteSubheading",
      options: {
        courseName: track && track.name
      }
    }),
    trackId: trackId
  });
};
export default ExamIncompleteExercisesScreen;